import logger from "./logger"
import settings from "./settings"
import windows from "./windows"

let loaded = false

export function isLoaded() {
  return loaded
}

const latestVersion = "!NWC_VERSION!"

export function resolveVersion({ version, latest }: { version: string; latest: string }) {
  const [vMajor, vMinor, vPatch] = version.split(".")
  const [lMajor, lMinor, lPatch] = latest.split(".")
  if (vMajor === lMajor && (+vMinor < +lMinor || (vMinor === lMinor && +vPatch < +lPatch))) {
    return latest
  }
  return version
}

export async function load() {
  if (loaded) {
    return
  }
  const { document } = windows.site
  const resolvedVersion = resolveVersion({
    version: settings.webComponentsVersion!,
    latest: latestVersion
  })
  const url = `https://cdn.jsdelivr.net/npm/@nosto/web-components@${resolvedVersion}/dist/main.es.bundle.js`
  const scriptElement = document.createElement("script")
  scriptElement.src = url
  scriptElement.type = "module"
  document.head.prepend(scriptElement)
  loaded = true
}

export async function initWebComponents() {
  if (settings.webComponents) {
    if (!settings.webComponentsVersion) {
      logger.info("Web components version not set, skipping web components init")
    } else {
      await load()
    }
  }
}
